import React from 'react';
import styles from './CardLayout.module.scss';

export interface CardLayoutProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  meta?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export default function CardLayout(
  {
    icon,
    title,
    subtitle,
    meta,
    actions,
    className
  }: CardLayoutProps
) {
  return (
    <div className={styles.cardLayoutOuter}>
      <div className={`${styles.cardLayout} ${className || ''}`}>
        <div className={styles.info}>
          <div className={styles.header}>
            <div className={styles.icon}>{icon}</div>
            <div className={styles.details}>
              <div className={styles.title}>{title}</div>
              {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
            </div>
          </div>
          {meta && <div className={styles.meta}>{meta}</div>}
        </div>

        {actions && (
          <div className={styles.actions}>
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
